var map = {
	"app/modules-core/dashboard/dashboard.module.ngfactory": [
		"EJ2F",
		0,
		3,
		1,
		7
	],
	"app/modules-core/principal/principal.module.ngfactory": [
		"40SW",
		0,
		3,
		1,
		8
	],
	"app/modules-core/profile/profile.module.ngfactory": [
		"tl46",
		0,
		1,
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;